// extracted by mini-css-extract-plugin
export default {"container":"Skillbox_container__qICQ5"};